/**
 * Rozhraní pro komponentu, která podporuje auto refresh
 * @includeToDoc
 * @generateInstanceClass
 */
export interface IHasAutorefresh {
    /** Resetuje timeout pro auto refresh. */
    resetRefreshTimeout(): void;
}

export class IHasAutorefresh {
    private static _methods = ["resetRefreshTimeout"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function");
    }
}
